import * as moment from 'moment';

import { AverageRevenuePerCustomerDTO } from '../dto/average-revenue-customer.dto';

export class AverageRevenuePerCustomer {
  public revenue: number;
  public dateTime: moment.Moment;

  public static fromDTO(
    revenueCustomerDto: AverageRevenuePerCustomerDTO
  ): AverageRevenuePerCustomer {
    const average: AverageRevenuePerCustomer = new AverageRevenuePerCustomer();
    average.revenue = revenueCustomerDto.avgRevenuePerCustomer;
    average.dateTime = moment(revenueCustomerDto.dateTime);
    return average;
  }
}
